import {
  EmbroideryLocation,
  PlacementId,
  fromPlacementId,
} from '../../../../../../containers/EmbroideryContainer/combination-rules/placementIds'

/** TODO: The items in this file are stubbed for now, get the real ones from Contentful when ready */

export type TextLimits = {
  lineCount: 1 | 2
  maxCharactersPerLine: number
}

const SLEEVE_LIMITS: TextLimits = { lineCount: 1, maxCharactersPerLine: 15 }
const CHEST_LIMITS: TextLimits = { lineCount: 2, maxCharactersPerLine: 26 }

const LIMITS_BY_LOCATION: Partial<Record<EmbroideryLocation, TextLimits>> = {
  CHEST: CHEST_LIMITS,
  SLEEVE: SLEEVE_LIMITS,
}

export const textLimitsFor = (placementId: PlacementId): TextLimits =>
  LIMITS_BY_LOCATION[fromPlacementId(placementId).location] ?? SLEEVE_LIMITS
